import React, { useEffect, useState } from "react";
import MaterialTable from 'material-table';
import { oldgenericApi } from '../../../common/apiconfig';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Materialtable from '../../../globalcomponents/materialtable'
import Loader from '../../../common/loader'
import AddHospital from "./addHospital";
function SiteGrid(props) {
  const [data, setData] = useState([])
  let [progress, setProgress] = useState(false);
  let [showHospital,setShowHospital] = useState(false)

  const handleRowClick = async (event, rowData) => {
    event.preventDefault()
    console.log(rowData,"rowData")
    props.UpdateFormField({name:"hospitalData",value:rowData})
    props.UpdateFormField({name:"hospitalName",value:rowData.accountName})
    props.UpdateFormField({name:"hospitalId",value:rowData.sponsorAccountId})
    props.setShowHospitals(false)
  }


  useEffect(() => {
    async function fetchData() {
      let requestBody = {
        query: `query {
        getAccountOfTypeSearch(accountType:"Site") {
          sponsorAccountId
          accountName
          parentAccountId
          accountType
          status
          address1
          address2
          city
          state
          country
          zip
          email
          phone
          
        }
        }`
      };

      requestBody = JSON.stringify(requestBody);
      setProgress(true);
      let res = await oldgenericApi('getAccountOfTypeSearch', requestBody);
      setProgress(false);
      if (!res) {
        // Error handling
        console.log('Error on response material grid!')

      } else {
        if (res.data.getAccountOfTypeSearch.length) {
          var data = res.data.getAccountOfTypeSearch
          setData(data)
        }
      }
    }
    fetchData()
    // fetch('https://clinicaltrials.gov/api/int/studies?cond=Heart Attack and Stroke&titles=heart').then(response => response.json())
    // .then((data) => {
    //   console.log(data,"apicall")
    // })
  }, [showHospital]);

  const Columns = [
    {
      title: 'Name', field: 'accountName',
      cellStyle: {
        color: '#244271',
        fontWeight: 500,
        width: '20%'
      },
    },
    {
      title: 'Type', field: 'accountType'
    },

    { title: "Parent ID", field: 'parentAccountId' },
    { title: 'Address', field: 'address1' },
    { title: 'City', field: 'city' },
    { title: 'Country', field: 'country' },
    // {title:"Status", field:'status'}
  ]
  return (
    <>
      <Loader progress={progress}/>
      {showHospital ? <AddHospital showHospital={()=>setShowHospital(false)}/> : <>
      <div className="d-flex mb-3 justify-content-end">
        <div className="mr-auto secondary-header">Hospital List</div>
        <div className="mt-2">
          <button onClick={()=>setShowHospital(true)} className="btn btn-primary-blue btn-rounded">
            <i className="fa fa-plus-circle mr-1"></i> ADD HOSPITAL</button>
        </div>
      </div>
    
      <div className="listing-wrap hekmaGrid">
        <div className="card">
          <div className="hekmaGridBox">
           
            <Materialtable
              columns={Columns}
              data={data}
              search={true}
              handleRowClick={handleRowClick}
            />
          </div>
        </div>
      </div></>}
    </>
  )

}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    }
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiteGrid));


